// src/components/Footer/Footer.js
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'; // <-- IMPORT useNavigate
import './Footer.css';

// SVG Icons (FacebookIcon, ArrowUpIcon, PhoneIcon) remain unchanged
const FacebookIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>
  </svg>
);

const ArrowUpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0l-12 12h7v12h10v-12h7z"/>
  </svg>
);

const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor">
    <path d="M0 0h24v24H0V0z" fill="none"/>
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
  </svg>
);

function Footer() {
  const currentYear = new Date().getFullYear();
  const [showScrollTop, setShowScrollTop] = useState(false);
  const phoneNumber = "07 59 63 97 39";
  const phoneNumberHref = "tel:0759639739";
  const facebookPageUrl = "https://www.facebook.com/profile.php?id=61554598546070&locale=fr_FR";

  const navigate = useNavigate(); // <-- Initialize the navigate function

  const checkScrollTop = () => {
    if (!showScrollTop && window.pageYOffset > 400) {
      setShowScrollTop(true);
    } else if (showScrollTop && window.pageYOffset <= 400) {
      setShowScrollTop(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScrollTop);
    return () => {
      window.removeEventListener('scroll', checkScrollTop);
    };
  }, [showScrollTop]);

  const handleHeartClick = (event) => {
    event.preventDefault(); // Good practice, though span is not a link by default
    // Navigate to the /jeux page
    navigate('/jeux');
  };

  return (
    <>
      <footer className="app-footer">
        <div className="container">
          <div className="footer-main-content">
            <div className="contact-info">
              <h4>Contactez-nous</h4>
              <p>Info-Alt</p>
              <p>2 rue des pénitents, 32220 Lombez</p>
              <p>Email : <a href="mailto:contact@info-alt.fr">contact@info-alt.fr</a></p>
              <p>Téléphone : <a href={phoneNumberHref}>{phoneNumber}</a></p>
            </div>

            <div className="footer-social">
              <h4>Suivez-nous</h4>
              <p className="social-cta">Restez connecté avec Info-Alt pour les dernières nouvelles et astuces !</p>
              <a href={facebookPageUrl} target="_blank" rel="noopener noreferrer" aria-label="Suivez-nous sur Facebook" className="social-link facebook-link">
                <FacebookIcon />
                <span>Facebook</span>
              </a>
            </div>
          </div>

          <div className="footer-bottom">
            <div className="legal-links">
              <Link to="/mentions-legales">Mentions Légales</Link>
            </div>
            <div className="copyright">
              <p>© {currentYear} Info-Alt. Tous droits réservés.</p>
              <p>
                Site développé avec{' '}
                <span
                  onClick={handleHeartClick}
                  onKeyPress={(e) => { if (e.key === 'Enter' || e.key === ' ') handleHeartClick(e);}}
                  className="heart-icon" // Ensure this class exists in Footer.css
                  role="button"
                  tabIndex={0} // Make it focusable
                  aria-label="Accéder à la section des jeux" // More direct aria-label
                  title="Cliquez pour découvrir..." // Mysterious title
                >
                  ❤️
                </span>
                {' '}à Lombez .
              </p>
              <p className="powered-by">
                Site propulsé par <a href="https://info-alt.com/" target="_blank" rel="noopener noreferrer">info-alt</a>.
              </p>
            </div>
          </div>
        </div>
      </footer>

      <a href={phoneNumberHref} className="sticky-phone-button" aria-label={`Appeler Info-Alt au ${phoneNumber}`}>
        <PhoneIcon />
        <span className="phone-button-text">{phoneNumber}</span>
      </a>

      {showScrollTop && (
        <button onClick={scrollTop} className="scroll-to-top-button" aria-label="Retourner en haut de la page">
          <ArrowUpIcon />
        </button>
      )}
    </>
  );
}

export default Footer;